import { siteRoot } from "@/helpers/siteRoot";
import { ImageModel } from "@/models/ImageModel";

export default {
    data() {
        return {
            DEF_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        }
    },
    methods: {
        getImage(imgData, domElementID = null) {
            if (!imgData) { // Пока нет картинки, показываем дефолтную
                return this.DEF_IMAGE;
            }
            if (imgData.includes('data:image')) { // Это base64 картинка
                return imgData;
            }
            if (imgData.includes('ref_')) { // Это ссылка на карту в IndexedDB
                if (!domElementID) {
                    return;
                }
                setTimeout( async () => {
                    const id = parseInt(imgData.replace('ref_', ''));
                    const m = new ImageModel(id);
                    await m.init();
                    const domElement = document.getElementById(domElementID);
                    domElement.src = m.value;
                }, 0);
                return this.DEF_IMAGE;
            }
            return siteRoot(imgData); // Это пусть к картинке на сервере
        },
        getImageByModel(model, domElementID) {
        }
    }
}